export * from "./trailing-text-input";
